import { ReactElement, ReactNode, useEffect, useState } from 'react';
import { Icon, Loading } from '@betrybe/ada-react';
import { Footer, Header } from '@/components/organisms';
import { useAuthentication, useClient } from '@/hooks';
import { GetClientData, useLogout } from '../utils';

type SimpleLayoutProps = {
  children: ReactNode;
};

export default function SimpleLayout(props: SimpleLayoutProps): ReactElement {
  const client = useClient();
  const { token } = useAuthentication();
  const { children } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const { logout } = useLogout();

  useEffect(() => {
    if (client.currentState) {
      setLoading(false);
    }
  }, [client.currentState]);

  return (
    <div className="layout-container">
      <GetClientData />
      <Header />
      {loading ? (
        <Loading>Aguarde...</Loading>
      ) : (
        <>
          {children}

          {token && (
            <div
              className="simple-layout-container__logout-link"
              onClick={() => logout(setLoading)}
              onKeyPress={() => logout(setLoading)}
              role="link"
              tabIndex={0}
            >
              <Icon name="input" height={24} />
              <p>Sair</p>
            </div>
          )}
        </>
      )}
      <Footer />
    </div>
  );
}
